import { Injectable } from '@angular/core';

import { HttpService, NotificationService, TmsWebBaseEditService } from 'tms-lib';
import { ProductCarpetSpec } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ProductCarpetSpecService extends TmsWebBaseEditService<ProductCarpetSpec, ProductCarpetSpec> {
  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('CarpetSpec', $localize`Carpet Spec`, httpService, notificationService);
  }
}
